import styled from 'styled-components';
import { orange, darkGrey, white } from '../../../../style/colors';

export const PriceFilterContainer = styled.div`
  padding: 10px 0;
`;

export const PriceInputRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 10px;
`;

export const PriceInput = styled.input`
  flex: 1;
  min-width: 0;
  max-width: 80px;
  padding: 6px 8px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 12px;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: ${orange};
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
  }

  &::placeholder {
    color: ${darkGrey};
    font-size: 11px;
  }
`;

export const PriceSeparator = styled.span`
  color: ${darkGrey};
  font-size: 12px;
  flex-shrink: 0;
`;

export const ApplyButton = styled.button`
  width: 100%;
  padding: 7px 12px;
  background-color: ${orange};
  color: ${white};
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #ff8c00;
  }

  &:active {
    transform: scale(0.98);
  }
`;

